import { render } from "./EditSubscriber.vue?vue&type=template&id=2923b725&scoped=true"
import script from "./EditSubscriber.vue?vue&type=script&lang=js"
export * from "./EditSubscriber.vue?vue&type=script&lang=js"

import "./EditSubscriber.vue?vue&type=style&index=0&id=2923b725&scoped=true&lang=css"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2923b725"]])

export default __exports__